import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import DetailedOrderBreadcrumbsContainer from '../../containers/breadcrumbs/detailed-order-breadcrumbs-container';
import DetailedOrderContainer from '../../containers/detailed-order-container';
import HintContainer from '../../containers/hints/hint-container';
import AppPageMain from '../../modules/app-page/app-page--main';
import { RootState } from '../../types';

const OrderDetailedPage: FC = () => {
  const isVisibleHint = useSelector((state: RootState) =>
    state.auth.profile.introHints.includes('ORDER_INTRO')
  );

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <DetailedOrderBreadcrumbsContainer />
          </div>
        </div>
        {isVisibleHint ? (
          <HintContainer hint="ORDER_INTRO" />
        ) : (
          <div className="row">
            <div className="col-19 col-lg-27 col-xl-35">
              <DetailedOrderContainer />
            </div>
          </div>
        )}
      </div>
    </AppPageMain>
  );
};

export default OrderDetailedPage;
